{
  "courses": {
    "title": "Cours & Formations",
    "createButton": "Nouveau cours",
    "createStudentButton": "Nouvel étudiant",
    "createTitle": "Créer un cours",
    "editTitle": "Modifier le cours",
    "backToList": "Retour aux cours",
    "searchPlaceholder": "Rechercher par titre ou lieu...",
    "allStatuses": "Tous les statuts",
    "allLevels": "Tous les niveaux",
    "noData": "Aucun cours trouvé",
    "noTeacher": "Aucun professeur",
    "nextSession": "Prochaine session :",
    "columns": {
      "title": "Titre",
      "level": "Niveau",
      "duration": "Durée",
      "price": "Prix",
      "status": "Statut",
      "nextSession": "Prochaine session",
      "fill": "Remplissage",
      "teachers": "Profs"
    },
    "level": {
      "Basic": "Initiation",
      "Intermediate": "Intermédiaire",
      "Expert": "Expert",
      "ExpertFinishes": "Expert — Finitions"
    },
    "status": {
      "Draft": "Brouillon",
      "Published": "Publié",
      "Archived": "Archivé"
    },
    "sessionStatus": {
      "Scheduled": "Planifiée",
      "Open": "Ouverte",
      "Full": "Complète",
      "Cancelled": "Annulée",
      "Completed": "Terminée"
    },
    "form": {
      "title": "Titre",
      "titleRequired": "Le titre est requis",
      "description": "Description",
      "level": "Niveau",
      "status": "Statut",
      "durationMinutes": "Durée (minutes)",
      "location": "Lieu",
      "language": "Langue",
      "maxStudents": "Nombre max. d'étudiants",
      "price": "Prix (EUR)"
    },
    "archive": {
      "title": "Archiver le cours",
      "confirm": "Archiver \"{{title}}\" ?",
      "action": "Archiver"
    },
    "sessions": {
      "title": "Sessions",
      "empty": "Aucune session pour l'instant",
      "noComing": "Aucune session à venir",
      "showPast": "Afficher les passées ({{count}})"
    },
    "session": {
      "createButton": "Ajouter une session",
      "createTitle": "Ajouter une session",
      "editTitle": "Modifier la session",
      "date": "Date",
      "startTime": "Heure de début",
      "endTime": "Heure de fin",
      "location": "Lieu",
      "country": "Pays",
      "availableSeats": "Places disponibles",
      "status": "Statut",
      "seats": "places",
      "until": "jusqu'au",
      "enrollments": "Inscrits",
      "students": "Étudiants",
      "noStudents": "Aucun inscrit",
      "addStudent": "Ajouter un élève",
      "edit": "Modifier la session",
      "deleteTitle": "Supprimer la session",
      "deleteConfirm": "Êtes-vous sûr de vouloir supprimer cette session ? Toutes les inscriptions seront supprimées.",
      "complete": "Terminer",
      "reopen": "Rouvrir"
    },
    "enroll": {
      "title": "Inscrire un étudiant",
      "button": "Inscrire",
      "action": "Inscrire",
      "search": "Rechercher des étudiants",
      "searchPlaceholder": "Tapez pour rechercher...",
      "student": "Étudiant",
      "studentPlaceholder": "Sélectionner un étudiant...",
      "noResults": "Aucun étudiant trouvé",
      "noEnrollments": "Aucune inscription pour l'instant",
      "remove": "Désinscrire",
      "removeTitle": "Retirer l'inscription",
      "removeConfirm": "Retirer {{name}} de cette session ?",
      "columns": {
        "name": "Nom",
        "email": "Email",
        "enrolledAt": "Inscrit le"
      }
    },
    "teachers": {
      "title": "Professeurs",
      "add": "Ajouter un professeur",
      "empty": "Aucun professeur assigné",
      "assign": "Assigner",
      "removeTitle": "Retirer le professeur",
      "removeConfirm": "Retirer {{name}} de ce cours ?",
      "select": "Sélectionner un professeur..."
    },
    "enrollmentStatus": {
      "Registered": "Inscrit",
      "Attended": "Présent",
      "Completed": "Complété",
      "Cancelled": "Annulé"
    },
    "attendance": {
      "edit": "Modifier la présence",
      "present": "Présent",
      "absent": "Absent",
      "comment": "Commentaire",
      "commentTitle": "Ajouter un commentaire",
      "commentPlaceholder": "Commentaire (facultatif)..."
    },
    "create": {
      "successTitle": "Formation créée",
      "successMessage": "La formation a été créée avec succès.",
      "errorTitle": "Erreur",
      "errorMessage": "Impossible de créer la formation."
    }
  }
}